export const chartjsPluginRadialArrow2 = {
    id: 'radialArrow2',
    afterDraw(chart, args, options) {
        const { angle } = options;
        const { ctx } = chart;
        const scale = chart.scales['r'];
        if (angle === null || angle === undefined) {
            return;
        }
        if (scale === undefined) {
            return;
        }
        const piAngle = angle * Math.PI / 180 - Math.PI / 2;
        const { width, height } = scale;
        // @ts-ignore
        let radius = scale.drawingArea - 1;
        // TODO: Почему-то drawingArea не учитывает ticks.display
        // @ts-ignore
        if (scale.options.ticks.display) {
            radius += 10;
        }
        const center = {
            x: width / 2,
            y: height / 2 + chart.height - height,
        };
        const anchor = {
            x: center.x + radius * Math.cos(piAngle),
            y: center.y + radius * Math.sin(piAngle),
        };
        drawArrow(ctx, anchor, piAngle, options.color);
        drawBorder(ctx, center, radius, piAngle, options.color);
    }
};
function drawArrow(ctx, point, piAngle, color) {
    ctx.save();
    ctx.translate(point.x, point.y);
    ctx.rotate(piAngle);
    ctx.beginPath();
    // draw arrow
    ctx.moveTo(0, 0);
    ctx.lineTo(0, -10);
    ctx.lineTo(0, -20);
    ctx.lineTo(10, 0);
    ctx.lineTo(0, 20);
    ctx.lineTo(0, 10);
    ctx.closePath();
    ctx.fillStyle = color;
    ctx.fill();
    ctx.restore();
}
function drawBorder(ctx, center, radius, piAngle, color) {
    const angleOffset = 15 * Math.PI / 180; // 15 degrees
    const startAngle = piAngle - angleOffset;
    const endAngle = piAngle + angleOffset;
    ctx.save();
    ctx.translate(center.x, center.y);
    ctx.beginPath();
    ctx.arc(0, 0, radius, startAngle, endAngle);
    ctx.strokeStyle = color;
    ctx.lineWidth = 4;
    ctx.stroke();
    ctx.restore();
}
//# sourceMappingURL=arrow2.js.map
